export const gameConstants = {
    LOAD_GAME_PAGE: 'LOAD_GAME_PAGE',
    LAUNCH_GAME: 'LAUNCH_GAME',
    UPDATE_MERCHANT_PROVIDER: 'UPDATE_MERCHANT_PROVIDER',
    UPDATE_MERCHANT_PROVIDER_CATEGORY: 'UPDATE_MERCHANT_PROVIDER_CATEGORY',
};
